export default function Services() {
  const services = [
    {
      icon: "ri-file-text-line",
      title: "Preparación de Impuestos",
      description: "Servicio profesional de preparación de impuestos para individuos y trabajadores independientes, enfocado en el cumplimiento adecuado de las leyes fiscales vigentes.",
      features: ["Impuestos personales", "Impuestos de negocios", "Declaraciones estatales", "Planificación fiscal"]
    },
    {
      icon: "ri-bank-card-line",
      title: "Aplicaciones y Renovaciones ITIN",
      description: "Ayudamos con la solicitud y renovación del Número de Identificación Personal del Contribuyente (ITIN) para personas que necesitan presentar declaraciones de impuestos.",
      features: ["Solicitud nueva", "Renovaciones", "Asistencia completa", "Documentación"]
    },
    {
      icon: "ri-steering-line",
      title: "Licencia de Conducir de Maryland",
      description: "Asistencia especializada para inmigrantes que necesitan obtener su licencia de conducir en Maryland. Lo guiamos en cada paso del proceso. No somos el MVA ni garantizamos la aprobación; brindamos orientación y apoyo durante el proceso",
      features: ["Preparación de documentos", "Orientación del proceso", "Apoyo completo", "Seguimiento"]
    },
    {
      icon: "ri-quill-pen-line",
      title: "Notario Remoto en Línea (RON)",
      description: "Servicios de notarización remota en línea convenientes y seguros, en pleno cumplimiento con las leyes vigentes del estado de Maryland para notarización remota. Notarice sus documentos desde la comodidad de su hogar u oficina con total validez legal.",
      features: ["Notarización remota", "Cumplimiento legal MD", "Horarios flexibles", "Seguro y válido"]
    },
    {
      icon: "ri-shield-check-line",
      title: "Servicios de Apostilla",
      description: "Certificación de apostilla para documentos que serán utilizados en países extranjeros. Procesamiento rápido y confiable de todos sus documentos importantes.",
      features: ["Certificación internacional", "Proceso rápido", "Documentos legales", "Reconocimiento mundial"]
    },
    {
      icon: "ri-customer-service-line",
      title: "Consultoría Personalizada",
      description: "Asesoramiento profesional adaptado a sus necesidades específicas. Nuestro equipo experto está aquí para responder todas sus preguntas y guiarlo.",
      features: ["Consultas privadas", "Soluciones a medida", "Expertos bilingües", "Apoyo continuo"]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-4">
            Nuestros Servicios
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Servicios Profesionales a Su Alcance
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ofrecemos una gama completa de servicios diseñados específicamente para satisfacer las necesidades de la comunidad inmigrante y de habla hispana en Maryland.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed text-sm">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-4 bg-teal-50 rounded-lg p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-full">
              <i className="ri-information-line text-xl text-white"></i>
            </div>
            <div className="text-left">
              <h4 className="font-bold text-gray-900 mb-1">¿No encuentra lo que busca?</h4>
              <p className="text-sm text-gray-600">Contáctenos para consultas sobre servicios adicionales</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
